// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.2s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.confirm-modal {
  background: white;
  border-radius: 12px;
  padding: 0;
  max-width: 420px;
  width: 90%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.modal-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 24px 24px 0 24px;
}

.modal-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.modal-icon.icon-danger {
  background-color: #fee2e2;
  color: #dc2626;
}

.modal-icon.icon-info {
  background-color: #dbeafe;
  color: #2563eb;
}

.modal-icon .material-symbols-outlined {
  font-size: 28px;
}

.modal-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
  flex: 1 1;
}

.modal-body {
  padding: 16px 24px 24px 24px;
}

.modal-message {
  font-size: 0.95rem;
  color: #4b5563;
  margin: 0 0 12px 0;
  line-height: 1.5;
}

.modal-warning {
  font-size: 0.875rem;
  color: #dc2626;
  margin: 0;
  padding: 12px;
  background-color: #fef2f2;
  border-radius: 6px;
  border-left: 3px solid #dc2626;
}

.modal-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  padding: 16px 24px 24px 24px;
  border-top: 1px solid #e5e7eb;
}

.modal-actions .btn {
  min-width: 100px;
  padding: 10px 20px;
  font-weight: 500;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.modal-actions .btn-ghost {
  background: transparent;
  border: 1px solid #e5e7eb;
  color: #6b7280;
}

.modal-actions .btn-ghost:hover {
  background: #f9fafb;
  border-color: #d1d5db;
}

.modal-actions .btn-danger {
  background: #dc2626;
  border: 1px solid #dc2626;
  color: white;
}

.modal-actions .btn-danger:hover {
  background: #b91c1c;
  border-color: #b91c1c;
}

.modal-actions .btn-primary {
  background: #2563eb;
  border: 1px solid #2563eb;
  color: white;
}

.modal-actions .btn-primary:hover {
  background: #1d4ed8;
  border-color: #1d4ed8;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/ConfirmModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,UAAU;EACV,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,SAAO;AACT;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB","sourcesContent":[".modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  animation: fadeIn 0.2s ease-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.confirm-modal {\n  background: white;\n  border-radius: 12px;\n  padding: 0;\n  max-width: 420px;\n  width: 90%;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  animation: slideIn 0.3s ease-out;\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateY(-20px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.modal-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 24px 24px 0 24px;\n}\n\n.modal-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.modal-icon.icon-danger {\n  background-color: #fee2e2;\n  color: #dc2626;\n}\n\n.modal-icon.icon-info {\n  background-color: #dbeafe;\n  color: #2563eb;\n}\n\n.modal-icon .material-symbols-outlined {\n  font-size: 28px;\n}\n\n.modal-title {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0;\n  flex: 1;\n}\n\n.modal-body {\n  padding: 16px 24px 24px 24px;\n}\n\n.modal-message {\n  font-size: 0.95rem;\n  color: #4b5563;\n  margin: 0 0 12px 0;\n  line-height: 1.5;\n}\n\n.modal-warning {\n  font-size: 0.875rem;\n  color: #dc2626;\n  margin: 0;\n  padding: 12px;\n  background-color: #fef2f2;\n  border-radius: 6px;\n  border-left: 3px solid #dc2626;\n}\n\n.modal-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  padding: 16px 24px 24px 24px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.modal-actions .btn {\n  min-width: 100px;\n  padding: 10px 20px;\n  font-weight: 500;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.modal-actions .btn-ghost {\n  background: transparent;\n  border: 1px solid #e5e7eb;\n  color: #6b7280;\n}\n\n.modal-actions .btn-ghost:hover {\n  background: #f9fafb;\n  border-color: #d1d5db;\n}\n\n.modal-actions .btn-danger {\n  background: #dc2626;\n  border: 1px solid #dc2626;\n  color: white;\n}\n\n.modal-actions .btn-danger:hover {\n  background: #b91c1c;\n  border-color: #b91c1c;\n}\n\n.modal-actions .btn-primary {\n  background: #2563eb;\n  border: 1px solid #2563eb;\n  color: white;\n}\n\n.modal-actions .btn-primary:hover {\n  background: #1d4ed8;\n  border-color: #1d4ed8;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
